import { BaseMark } from '../BaseMark.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'dipli';
const args = {};

export class Dipli extends BaseMark {
  constructor() {
    super(glyphname, args);
  }
}
